import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    label: 'Late payment penalties',
    lateFeeHint: 'Legally, the minimum late penalty should be {min}%.',
    link: 'Learn more',
  },
  fr: {
    label: 'Pénalités de retard',
    lateFeeHint:
      'Légalement, la pénalité de retard minimum doit être de {min}\xA0%.',
    link: 'En savoir plus',
  },
} as const);

export default locales;
